export default __webpack_public_path__ + "static/media/bft-foundation-group-shot@2x.f0e217e1.png";